// extracted by mini-css-extract-plugin
module.exports = {"tabs":"StoryblokTabs_tabs__gNX3K","tabs__list":"StoryblokTabs_tabs__list__pzMRa"};